goog.provide("shadow.js.shim.module$$mui$material$Box$default");
shadow.js.shim.module$$mui$material$Box$default = shadow.js.require(399, {})["default"];
